export const ENTITY_EMAIL_DOCUMENTS = {
  debitNote: [
    { value: "debitNote", label: "Debit Note PDF" },
    { value: "debitNoteReceipt", label: "Receipt PDF" },
  ],
  renewal: [
    { value: "renewalNotice", label: "Renewal Notice PDF" },
    { value: "renewalCancelNotice", label: "Cancel Notice PDF" },
  ],
  order: [{ value: "orderCoverSheet", label: "Submission cover sheet PDF" }],
  quotation: [
    { value: "quotation", label: "Quotation PDF" },
    { value: "quotationConfirmation", label: "Confirmation letter PDF" },
  ],
  orderInvestmentTransaction: [
    { value: "arForm", label: "AR Form PDF" },
  ],
  clientPayment: [
    { value: "clientPaymentReceipts", label: "Uploaded payment receipts" },
  ],
};

export function documentsForEntity(entity) {
  return ENTITY_EMAIL_DOCUMENTS[entity] || [];
}

export function withCustomDocuments(entity, customDocs) {
  const standard = documentsForEntity(entity);
  const extra = (Array.isArray(customDocs) ? customDocs : [])
    .filter((doc) => doc && doc.active !== false && doc.template?.isUploaded)
    .map((doc) => ({
      value: doc.attachmentKey || `custom:${doc._id}`,
      label: doc.name,
    }));
  if (!extra.length) return standard;
  if (!standard.length) {
    return extra.map((doc) => ({ ...doc, group: "Custom" }));
  }
  return [
    ...standard.map((doc) => ({ ...doc, group: "Standard" })),
    ...extra.map((doc) => ({ ...doc, group: "Custom" })),
  ];
}
